import HomeAppSection from '@/components/HomeAppSection';
import HomeFreeSection from '@/components/HomeFreeSection';
import HomeHowItWorks from '@/components/HomeHowItWorks';
import HomePremiumSection from '@/components/HomePremiumSection';
import HomePrivacySection from '@/components/HomePrivacySection';

export default function HomeLandingSections() {
  return (
    <>
      <HomeFreeSection />
      <HomePremiumSection />
      <HomeHowItWorks />
      <HomePrivacySection />
      <HomeAppSection />
    </>
  );
}
